import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'listing-syndication-api.vendasta-local.com',
  'test': '',
  'demo': 'listing-syndication-demo.apigateway.co',
  'prod': 'listing-syndication-prod.apigateway.co',
  'production': 'listing-syndication-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
class DataValidationRequest {
  static fromProto(proto) {
    let m = new DataValidationRequest();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.force !== 'undefined') {
      toReturn['force'] = this.force;
    }
    return toReturn;
  }
}
class DataValidationResponse {
  static fromProto(proto) {
    let m = new DataValidationResponse();
    m = Object.assign(m, proto);
    if (proto.result) {
      m.result = proto.result.map(ValidationResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.result !== 'undefined' && this.result !== null) {
      toReturn['result'] = 'toApiJson' in this.result ? this.result.toApiJson() : this.result;
    }
    return toReturn;
  }
}
class DetailedSyndicationStatusResultValue {
  static fromProto(proto) {
    let m = new DetailedSyndicationStatusResultValue();
    m = Object.assign(m, proto);
    if (proto.lastSyncTime) {
      m.lastSyncTime = new Date(proto.lastSyncTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dataType !== 'undefined') {
      toReturn['dataType'] = this.dataType;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.syncedFields !== 'undefined') {
      toReturn['syncedFields'] = this.syncedFields;
    }
    if (typeof this.failedFields !== 'undefined') {
      toReturn['failedFields'] = this.failedFields;
    }
    if (typeof this.lastSyncTime !== 'undefined' && this.lastSyncTime !== null) {
      toReturn['lastSyncTime'] = 'toApiJson' in this.lastSyncTime ? this.lastSyncTime.toApiJson() : this.lastSyncTime;
    }
    if (typeof this.errorMessage !== 'undefined') {
      toReturn['errorMessage'] = this.errorMessage;
    }
    return toReturn;
  }
}
class DetailedSyndicationStatusResults {
  static fromProto(proto) {
    let m = new DetailedSyndicationStatusResults();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = DetailedSyndicationStatusResultValue.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class EnableSyndicationToSourceRequest {
  static fromProto(proto) {
    let m = new EnableSyndicationToSourceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class FieldValidationResult {
  static fromProto(proto) {
    let m = new FieldValidationResult();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.messages !== 'undefined') {
      toReturn['messages'] = this.messages;
    }
    return toReturn;
  }
}
class GetEditionSourceConfigRequest {
  static fromProto(proto) {
    let m = new GetEditionSourceConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    return toReturn;
  }
}
class GetEditionSourceConfigResponse {
  static fromProto(proto) {
    let m = new GetEditionSourceConfigResponse();
    m = Object.assign(m, proto);
    if (proto.freeSourceIds) {
      m.freeSourceIds = proto.freeSourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.freeSourceIds !== 'undefined') {
      toReturn['freeSourceIds'] = this.freeSourceIds;
    }
    return toReturn;
  }
}
class GetMultiMostRecentSyndicationStatusRequest {
  static fromProto(proto) {
    let m = new GetMultiMostRecentSyndicationStatusRequest();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    return toReturn;
  }
}
class GetMultiMostRecentSyndicationStatusResponse {
  static fromProto(proto) {
    let m = new GetMultiMostRecentSyndicationStatusResponse();
    m = Object.assign(m, proto);
    if (proto.syndicationStatuses) {
      m.syndicationStatuses = proto.syndicationStatuses.map(SyndicationStatus.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.syndicationStatuses !== 'undefined' && this.syndicationStatuses !== null) {
      toReturn['syndicationStatuses'] = 'toApiJson' in this.syndicationStatuses ? this.syndicationStatuses.toApiJson() : this.syndicationStatuses;
    }
    return toReturn;
  }
}
class ListSyndicationSettingRequest {
  static fromProto(proto) {
    let m = new ListSyndicationSettingRequest();
    m = Object.assign(m, proto);
    if (proto.filters) {
      m.filters = ListSyndicationSettingRequestOptionalListSyndicationSettingFilters.fromProto(proto.filters);
    }
    if (proto.pageOptions) {
      m.pageOptions = PagedRequestOptions.fromProto(proto.pageOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.pageOptions !== 'undefined' && this.pageOptions !== null) {
      toReturn['pageOptions'] = 'toApiJson' in this.pageOptions ? this.pageOptions.toApiJson() : this.pageOptions;
    }
    return toReturn;
  }
}
class ListSyndicationSettingResponse {
  static fromProto(proto) {
    let m = new ListSyndicationSettingResponse();
    m = Object.assign(m, proto);
    if (proto.syndicationSettings) {
      m.syndicationSettings = proto.syndicationSettings.map(SyndicationSetting.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.syndicationSettings !== 'undefined' && this.syndicationSettings !== null) {
      toReturn['syndicationSettings'] = 'toApiJson' in this.syndicationSettings ? this.syndicationSettings.toApiJson() : this.syndicationSettings;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Metadata {
  static fromProto(proto) {
    let m = new Metadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class ListSyndicationSettingRequestOptionalListSyndicationSettingFilters {
  static fromProto(proto) {
    let m = new ListSyndicationSettingRequestOptionalListSyndicationSettingFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    return toReturn;
  }
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class SetAssociatedSocialServiceRequest {
  static fromProto(proto) {
    let m = new SetAssociatedSocialServiceRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.associatedSocialServiceId !== 'undefined') {
      toReturn['associatedSocialServiceId'] = this.associatedSocialServiceId;
    }
    return toReturn;
  }
}
class SetEditionSourceConfigRequest {
  static fromProto(proto) {
    let m = new SetEditionSourceConfigRequest();
    m = Object.assign(m, proto);
    if (proto.freeSourceIds) {
      m.freeSourceIds = proto.freeSourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.namespace !== 'undefined') {
      toReturn['namespace'] = this.namespace;
    }
    if (typeof this.freeSourceIds !== 'undefined') {
      toReturn['freeSourceIds'] = this.freeSourceIds;
    }
    return toReturn;
  }
}
class SetSyndicationStatusRequest {
  static fromProto(proto) {
    let m = new SetSyndicationStatusRequest();
    m = Object.assign(m, proto);
    if (proto.metadata) {
      m.metadata = proto.metadata.map(Metadata.fromProto);
    }
    if (proto.lastAttemptedOn) {
      m.lastAttemptedOn = new Date(proto.lastAttemptedOn);
    }
    if (proto.lastSucceededOn) {
      m.lastSucceededOn = new Date(proto.lastSucceededOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.listingExternalId !== 'undefined') {
      toReturn['listingExternalId'] = this.listingExternalId;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.lastAttemptedOn !== 'undefined' && this.lastAttemptedOn !== null) {
      toReturn['lastAttemptedOn'] = 'toApiJson' in this.lastAttemptedOn ? this.lastAttemptedOn.toApiJson() : this.lastAttemptedOn;
    }
    if (typeof this.lastSucceededOn !== 'undefined' && this.lastSucceededOn !== null) {
      toReturn['lastSucceededOn'] = 'toApiJson' in this.lastSucceededOn ? this.lastSucceededOn.toApiJson() : this.lastSucceededOn;
    }
    return toReturn;
  }
}
class SubmitListingSyndicationRequest {
  static fromProto(proto) {
    let m = new SubmitListingSyndicationRequest();
    m = Object.assign(m, proto);
    if (proto.sourceIds) {
      m.sourceIds = proto.sourceIds.map(i => parseInt(i, 10));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sourceIds !== 'undefined') {
      toReturn['sourceIds'] = this.sourceIds;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.trigger !== 'undefined') {
      toReturn['trigger'] = this.trigger;
    }
    if (typeof this.force !== 'undefined') {
      toReturn['force'] = this.force;
    }
    return toReturn;
  }
}
class SubmitListingSyndicationResponse {
  static fromProto(proto) {
    let m = new SubmitListingSyndicationResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.workflowId !== 'undefined') {
      toReturn['workflowId'] = this.workflowId;
    }
    return toReturn;
  }
}
class SyndicationSetting {
  static fromProto(proto) {
    let m = new SyndicationSetting();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.lastSyndicationOnTime) {
      m.lastSyndicationOnTime = new Date(proto.lastSyndicationOnTime);
    }
    if (proto.lastSyndicationOffTime) {
      m.lastSyndicationOffTime = new Date(proto.lastSyndicationOffTime);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.syndicationOn !== 'undefined') {
      toReturn['syndicationOn'] = this.syndicationOn;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.lastSyndicationOnTime !== 'undefined' && this.lastSyndicationOnTime !== null) {
      toReturn['lastSyndicationOnTime'] = 'toApiJson' in this.lastSyndicationOnTime ? this.lastSyndicationOnTime.toApiJson() : this.lastSyndicationOnTime;
    }
    if (typeof this.lastSyndicationOffTime !== 'undefined' && this.lastSyndicationOffTime !== null) {
      toReturn['lastSyndicationOffTime'] = 'toApiJson' in this.lastSyndicationOffTime ? this.lastSyndicationOffTime.toApiJson() : this.lastSyndicationOffTime;
    }
    if (typeof this.sourceLocationId !== 'undefined') {
      toReturn['sourceLocationId'] = this.sourceLocationId;
    }
    if (typeof this.associatedSocialServiceId !== 'undefined') {
      toReturn['associatedSocialServiceId'] = this.associatedSocialServiceId;
    }
    return toReturn;
  }
}
class SyndicationStatus {
  static fromProto(proto) {
    let m = new SyndicationStatus();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.lastAttemptedOn) {
      m.lastAttemptedOn = new Date(proto.lastAttemptedOn);
    }
    if (proto.lastSucceededOn) {
      m.lastSucceededOn = new Date(proto.lastSucceededOn);
    }
    if (proto.detailedResults) {
      m.detailedResults = proto.detailedResults.map(DetailedSyndicationStatusResults.fromProto);
    }
    if (proto.metadata) {
      m.metadata = proto.metadata.map(Metadata.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceLocationId !== 'undefined') {
      toReturn['sourceLocationId'] = this.sourceLocationId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.lastAttemptedOn !== 'undefined' && this.lastAttemptedOn !== null) {
      toReturn['lastAttemptedOn'] = 'toApiJson' in this.lastAttemptedOn ? this.lastAttemptedOn.toApiJson() : this.lastAttemptedOn;
    }
    if (typeof this.lastSucceededOn !== 'undefined' && this.lastSucceededOn !== null) {
      toReturn['lastSucceededOn'] = 'toApiJson' in this.lastSucceededOn ? this.lastSucceededOn.toApiJson() : this.lastSucceededOn;
    }
    if (typeof this.listingUrl !== 'undefined') {
      toReturn['listingUrl'] = this.listingUrl;
    }
    if (typeof this.listingExternalId !== 'undefined') {
      toReturn['listingExternalId'] = this.listingExternalId;
    }
    if (typeof this.lastSyncAttemptId !== 'undefined') {
      toReturn['lastSyncAttemptId'] = this.lastSyncAttemptId;
    }
    if (typeof this.lastSuccessfulAttemptId !== 'undefined') {
      toReturn['lastSuccessfulAttemptId'] = this.lastSuccessfulAttemptId;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.detailedResults !== 'undefined' && this.detailedResults !== null) {
      toReturn['detailedResults'] = 'toApiJson' in this.detailedResults ? this.detailedResults.toApiJson() : this.detailedResults;
    }
    if (typeof this.metadata !== 'undefined' && this.metadata !== null) {
      toReturn['metadata'] = 'toApiJson' in this.metadata ? this.metadata.toApiJson() : this.metadata;
    }
    if (typeof this.force !== 'undefined') {
      toReturn['force'] = this.force;
    }
    return toReturn;
  }
}
class TurnOffSyndicationSettingRequest {
  static fromProto(proto) {
    let m = new TurnOffSyndicationSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    return toReturn;
  }
}
class TurnOnSyndicationSettingRequest {
  static fromProto(proto) {
    let m = new TurnOnSyndicationSettingRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.sourceLocationId !== 'undefined') {
      toReturn['sourceLocationId'] = this.sourceLocationId;
    }
    if (typeof this.associatedSocialServiceId !== 'undefined') {
      toReturn['associatedSocialServiceId'] = this.associatedSocialServiceId;
    }
    return toReturn;
  }
}
class ValidationResult {
  static fromProto(proto) {
    let m = new ValidationResult();
    m = Object.assign(m, proto);
    if (proto.sourceId) {
      m.sourceId = parseInt(proto.sourceId, 10);
    }
    if (proto.fieldValidationResult) {
      m.fieldValidationResult = proto.fieldValidationResult.map(FieldValidationResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isValid !== 'undefined') {
      toReturn['isValid'] = this.isValid;
    }
    if (typeof this.sourceId !== 'undefined') {
      toReturn['sourceId'] = this.sourceId;
    }
    if (typeof this.fieldValidationResult !== 'undefined' && this.fieldValidationResult !== null) {
      toReturn['fieldValidationResult'] = 'toApiJson' in this.fieldValidationResult ? this.fieldValidationResult.toApiJson() : this.fieldValidationResult;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SyndicationApiService = /*#__PURE__*/(() => {
  class SyndicationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    submitListingSyndication(r) {
      const request = r.toApiJson ? r : new SubmitListingSyndicationRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/SubmitListingSyndication", request.toApiJson(), this.apiOptions()).pipe(map(resp => SubmitListingSyndicationResponse.fromProto(resp)));
    }
    dataValidation(r) {
      const request = r.toApiJson ? r : new DataValidationRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/DataValidation", request.toApiJson(), this.apiOptions()).pipe(map(resp => DataValidationResponse.fromProto(resp)));
    }
    getMultiMostRecentSyndicationStatus(r) {
      const request = r.toApiJson ? r : new GetMultiMostRecentSyndicationStatusRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/GetMultiMostRecentSyndicationStatus", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiMostRecentSyndicationStatusResponse.fromProto(resp)));
    }
    setSyndicationStatus(r) {
      const request = r.toApiJson ? r : new SetSyndicationStatusRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/SetSyndicationStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    turnOnSyndication(r) {
      const request = r.toApiJson ? r : new TurnOnSyndicationSettingRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/TurnOnSyndication", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    turnOffSyndication(r) {
      const request = r.toApiJson ? r : new TurnOffSyndicationSettingRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/TurnOffSyndication", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    setAssociatedSocialService(r) {
      const request = r.toApiJson ? r : new SetAssociatedSocialServiceRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/SetAssociatedSocialService", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listSyndicationSettings(r) {
      const request = r.toApiJson ? r : new ListSyndicationSettingRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/ListSyndicationSettings", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListSyndicationSettingResponse.fromProto(resp)));
    }
    setEditionSourceConfig(r) {
      const request = r.toApiJson ? r : new SetEditionSourceConfigRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/SetEditionSourceConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getEditionSourceConfig(r) {
      const request = r.toApiJson ? r : new GetEditionSourceConfigRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/GetEditionSourceConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetEditionSourceConfigResponse.fromProto(resp)));
    }
    enableSyndicationToSource(r) {
      const request = r.toApiJson ? r : new EnableSyndicationToSourceRequest(r);
      return this.http.post(this._host + "/listing_syndication.v1.SyndicationService/EnableSyndicationToSource", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  SyndicationApiService.ɵfac = function SyndicationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SyndicationApiService)();
  };
  SyndicationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SyndicationApiService,
    factory: SyndicationApiService.ɵfac,
    providedIn: 'root'
  });
  return SyndicationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************

/**
 * Generated bundle index. Do not edit.
 */

export { Access, DataValidationRequest, DataValidationResponse, DetailedSyndicationStatusResultValue, DetailedSyndicationStatusResults, EnableSyndicationToSourceRequest, FieldValidationResult, GetEditionSourceConfigRequest, GetEditionSourceConfigResponse, GetMultiMostRecentSyndicationStatusRequest, GetMultiMostRecentSyndicationStatusResponse, HostService, ListSyndicationSettingRequest, ListSyndicationSettingRequestOptionalListSyndicationSettingFilters, ListSyndicationSettingResponse, Metadata, PagedRequestOptions, PagedResponseMetadata, SetAssociatedSocialServiceRequest, SetEditionSourceConfigRequest, SetSyndicationStatusRequest, SubmitListingSyndicationRequest, SubmitListingSyndicationResponse, SyndicationApiService, SyndicationSetting, SyndicationStatus, TurnOffSyndicationSettingRequest, TurnOnSyndicationSettingRequest, ValidationResult };
